// import React, { useRef, useState } from "react";
// import axios from "axios";
// import { MdUpload } from "react-icons/md";

// import { bulkImportAPI } from "../../api/bulkImport.api";

// const BulkImportButton = ({ module, label = "Import", onSuccess, companyId }) => {
//   const fileInputRef = useRef(null);
//   const [loading, setLoading] = useState(false);
//   const [result, setResult] = useState(null);
//   const [alertData, setAlertData] = useState({
//     type: "",
//     message: "",
//   });

//   const handleButtonClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("file", file);
//     if (companyId) {
//       formData.append("company_id", companyId);
//     }

//      try {
//       setLoading(true);

//       const res = await bulkImportAPI(module, formData);

//       const data = res.data;

//       setAlertData({
//         type: data.failed > 0 ? "warning" : "success",
//         message: `${label} completed. Imported: ${data.imported}/${data.total}, Failed: ${data.failed}`,
//       });

//       if (onSuccess) {
//         onSuccess();
//       }
//     } catch (error) {
//       setAlertData({
//         type: "error",
//         message:
//           error.response?.data?.message || `${label} failed. Please try again.`,
//       });
//     } finally {
//       setLoading(false);
//       e.target.value = null;
//     }
//   };

//   return (
//     <div>
//       <button
//         onClick={handleButtonClick}
//         className="btn-primary"
//       >
//         <MdUpload className="text-lg" />
//         {loading ? "Uploading..." : label}

//       </button>

//       <input
//         type="file"
//         accept=".csv"
//         ref={fileInputRef}
//         onChange={handleFileChange}
//         style={{ display: "none" }}
//       />

//       {result && (
//         <div className="mt-4 p-3 bg-gray-100 rounded">
//           <p>Total: {result.total}</p>
//           <p>Imported: {result.imported}</p>
//           <p>Failed: {result.failed}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BulkImportButton;
import React, { useRef, useState } from "react";
import {
  MdUpload,
  MdClose,
  MdDownload,
  MdErrorOutline,
  MdCheckCircleOutline,
} from "react-icons/md";
import { bulkImportAPI } from "../../api/bulkImport.api";

const BulkImportButton = ({
  module,
  label = "Import",
  onSuccess,
  companyId,
}) => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    if (companyId) {
      formData.append("company_id", companyId);
    }

    try {
      setLoading(true);
      const res = await bulkImportAPI(module, formData);
      const data = res.data;
      console.log("data",data)

      setImportResult(data);
      setShowModal(true);

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      // In case of complete network/server breakdown
      setImportResult({
        total: 0,
        validCount: 0,
        nonValidCount: 1,
        nonValidData: [
          {
            row: "-",
            data: { file: file.name },
            reason:
              error.response?.data?.message ||
              "Server or network error encountered during upload.",
          },
        ],
      });
      setShowModal(true);
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  // Download Non-Valid Exhibitors as a CSV file
  const downloadFailedRowsCSV = () => {
    if (!importResult?.nonValidData?.length) return;

    const failedRows = importResult.nonValidData;

    // Collect all unique data keys across all failed rows dynamically
    const dataKeys = Array.from(
      new Set(failedRows.flatMap((item) => Object.keys(item.data || {})))
    );

    const headers = ["Row Number", "Failure Reason", ...dataKeys];

    const csvRows = failedRows.map((item) => {
      const rowNum = item.row;
      const reason = `"${(item.reason || "").replace(/"/g, '""')}"`;
      const rowData = dataKeys.map(
        (key) => `"${(item.data?.[key] ?? "").toString().replace(/"/g, '""')}"`
      );
      return [rowNum, reason, ...rowData].join(",");
    });

    const csvString = [headers.join(","), ...csvRows].join("\n");

    // Create a Blob to handle all special characters (#, %, &, unicode) without truncation
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `failed_import_rows_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      {/* Upload Trigger Button */}
      <button
        onClick={handleButtonClick}
        disabled={loading}
        className="btn-primary flex items-center gap-1.5 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <MdUpload className="text-lg" />
        {loading ? "Importing..." : label}
      </button>

      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      {/* 1. FULL-PAGE SPINNER / LOADER OVERLAY */}
      {loading && (
        <div className="bg-black/50 fixed inset-0 z-50 flex flex-col items-center justify-center backdrop-blur-sm">
          <div className="flex flex-col items-center rounded-2xl bg-white p-8 shadow-2xl dark:bg-navy-800">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-brand-500"></div>
            <p className="mt-4 text-sm font-semibold text-gray-800 dark:text-white">
              Processing and Validating Bulk Import...
            </p>
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Please wait while records and onboarding credentials are created.
            </p>
          </div>
        </div>
      )}

      {/* 2. RESULT SUMMARY MODAL */}
      {showModal && importResult && (
        <div className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
          <div className="w-full max-w-2xl rounded-2xl bg-white p-6 shadow-2xl dark:bg-navy-800">
            {/* Modal Header */}
            <div className="flex items-center justify-between border-b border-gray-100 pb-4 dark:border-white/10">
              <h3 className="text-lg font-bold text-gray-800 dark:text-white">
                Import Completion Summary
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-white/10 dark:hover:text-white"
              >
                <MdClose className="text-xl" />
              </button>
            </div>

            {/* Modal Body: Stats Cards */}
            <div className="my-5 grid grid-cols-3 gap-4">
              <div className="rounded-xl border border-gray-100 bg-gray-50/50 p-4 text-center dark:border-white/10 dark:bg-navy-700">
                <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
                  Total Processed
                </span>
                <p className="mt-1 text-2xl font-bold text-gray-800 dark:text-white">
                  {importResult.total || 0}
                </p>
              </div>

              <div className="border-emerald-100 bg-emerald-50/40 dark:border-emerald-500/20 dark:bg-emerald-500/10 rounded-xl border p-4 text-center">
                <div className="text-emerald-600 flex items-center justify-center gap-1">
                  <MdCheckCircleOutline className="text-base" />
                  <span className="text-xs font-semibold">Success</span>
                </div>
                <p className="text-emerald-600 mt-1 text-2xl font-bold">
                  {importResult.validCount || importResult.imported || 0}
                </p>
              </div>

              <div className="border-rose-100 bg-rose-50/40 dark:border-rose-500/20 dark:bg-rose-500/10 rounded-xl border p-4 text-center">
                <div className="text-rose-600 flex items-center justify-center gap-1">
                  <MdErrorOutline className="text-base" />
                  <span className="text-xs font-semibold">Failed</span>
                </div>
                <p className="text-rose-600 mt-1 text-2xl font-bold">
                  {importResult.nonValidCount ||
                    importResult.nonValidExhibitors?.length ||
                    0}
                </p>
              </div>
            </div>

            {/* Failed Rows Section (if nonValidExhibitors exist) */}
            {importResult.nonValidData &&
            importResult.nonValidData.length > 0 ? (
              <div className="mt-4">
                <div className="mb-2 flex items-center justify-between">
                  <span className="text-rose-600 dark:text-rose-400 text-xs font-bold">
                    Failed Rows ({importResult.nonValidData.length})
                  </span>

                  <button
                    onClick={downloadFailedRowsCSV}
                    className="border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100 dark:border-rose-500/30 dark:bg-rose-500/10 dark:text-rose-300 flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold transition"
                  >
                    <MdDownload className="text-base" />
                    Download Failed Rows CSV
                  </button>
                </div>

                {/* Table Preview of Failure Reasons */}
                <div className="max-h-52 overflow-y-auto rounded-xl border border-gray-200/80 bg-white dark:border-white/10 dark:bg-navy-900">
                  <table className="w-full text-left text-xs">
                    <thead className="sticky top-0 bg-gray-50 font-semibold text-gray-600 dark:bg-navy-800 dark:text-gray-300">
                      <tr>
                        <th className="px-3 py-2">Row</th>
                        <th className="px-3 py-2">Primary Identifier</th>
                        <th className="px-3 py-2">Failure Reason</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-white/5">
                      {importResult.nonValidData.map((err, idx) => (
                        <tr
                          key={idx}
                          className="hover:bg-gray-50/50 dark:hover:bg-white/5"
                        >
                          <td className="px-3 py-2 font-mono text-gray-500 dark:text-gray-400">
                            #{err.row}
                          </td>
                          <td className="px-3 py-2 font-medium text-gray-800 dark:text-gray-200">
                            {err.data?.title || err.data?.email || "N/A"}
                          </td>
                          <td className="text-rose-600 dark:text-rose-400 px-3 py-2 font-medium">
                            {err.reason}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="border-emerald-100 bg-emerald-50/50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-400 my-4 rounded-xl border p-4 text-center text-xs font-medium">
                All records were validated and imported successfully with zero
                errors!
              </div>
            )}

            {/* Modal Footer */}
            {/* <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="rounded-xl bg-gray-900 px-5 py-2 text-xs font-semibold text-white hover:bg-gray-800 dark:bg-white dark:text-gray-900"
              >
                Done
              </button>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkImportButton;
